module.exports = __webpack_public_path__ + "static/media/white-power-transmission.4a9671b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-power-transmission.svg
// module id = 311
// module chunks = 0